import { render, staticRenderFns } from "./dilu-table.vue?vue&type=template&id=54398c32&scoped=true"
import script from "./dilu-table.vue?vue&type=script&lang=js"
export * from "./dilu-table.vue?vue&type=script&lang=js"
import style0 from "./dilu-table.vue?vue&type=style&index=0&id=54398c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54398c32",
  null
  
)

export default component.exports